// noinspection OverlyComplexBooleanExpressionJS

import {
  ICON_TITLE_INFO_ADDITIONAL_INFO_LAYOUT,
  ICON_TITLE_INFO_LAYOUT,
  ICON_TITLE_LAYOUT,
  ICON_TITLE_PRICE_INFO_LAYOUT,
  ICON_TITLE_PRICE_LAYOUT,
  TITLE_LAYOUT,
  TITLE_PRICE_BUTTON_LAYOUT,
  TITLE_INFO_PRICE_LAYOUT,
  TITLE_PRICE_LAYOUT,
} from './constants/layout';
import { IComponentLayout, ICartLayoutProps } from './model';

export const getLayout = (components: ICartLayoutProps): IComponentLayout | null => {
  if (components.overrideLayout) {
    return components.overrideLayout;
  }
  if (isExtendedAdditionalLayout(components)) {
    return ICON_TITLE_INFO_ADDITIONAL_INFO_LAYOUT;
  }

  if (isIconTitleInfoPriceLayout(components)) {
    return ICON_TITLE_PRICE_INFO_LAYOUT;
  }

  if (isIconTitlePriceLayout(components)) {
    return ICON_TITLE_PRICE_LAYOUT;
  }

  if (isIconTitleInfoLayout(components)) {
    return ICON_TITLE_INFO_LAYOUT;
  }

  if (isInfoBodyPriceLayout(components)) {
    return TITLE_INFO_PRICE_LAYOUT;
  }

  if (isBodyPriceButtonLayout(components)) {
    return TITLE_PRICE_BUTTON_LAYOUT;
  }

  if (isBodyPriceLayout(components)) {
    return TITLE_PRICE_LAYOUT;
  }

  if (isIconTitleLayout(components)) {
    return ICON_TITLE_LAYOUT;
  }

  if (components.bodyColumn) {
    return TITLE_LAYOUT;
  }

  return null;
};

const isExtendedAdditionalLayout = ({
  iconColumn,
  bodyColumn,
  infoColumn,
  priceColumn,
  perPieceColumn,
  piecesColumn,
  additionalColumn,
}: ICartLayoutProps): boolean =>
  Boolean(iconColumn) &&
  Boolean(bodyColumn) &&
  Boolean(infoColumn) &&
  Boolean(priceColumn) &&
  Boolean(perPieceColumn) &&
  Boolean(piecesColumn) &&
  Boolean(additionalColumn);

const isIconTitleInfoPriceLayout = ({ iconColumn, bodyColumn, infoColumn, priceColumn }: ICartLayoutProps): boolean =>
  Boolean(iconColumn) && Boolean(bodyColumn) && Boolean(infoColumn) && Boolean(priceColumn);

const isIconTitlePriceLayout = ({ iconColumn, bodyColumn, priceColumn }: ICartLayoutProps): boolean =>
  Boolean(iconColumn) && Boolean(bodyColumn) && Boolean(priceColumn);

const isIconTitleInfoLayout = ({ iconColumn, bodyColumn, infoColumn }: ICartLayoutProps): boolean =>
  Boolean(iconColumn) && Boolean(bodyColumn) && Boolean(infoColumn);

const isInfoBodyPriceLayout = ({ infoColumn, bodyColumn, priceColumn }: ICartLayoutProps): boolean =>
  Boolean(infoColumn) && Boolean(bodyColumn) && Boolean(priceColumn);

const isBodyPriceButtonLayout = ({ bodyColumn, priceColumn, buttonColumn }: ICartLayoutProps): boolean =>
  Boolean(bodyColumn) && Boolean(priceColumn) && Boolean(buttonColumn);

const isBodyPriceLayout = ({ bodyColumn, priceColumn }: ICartLayoutProps): boolean =>
  Boolean(bodyColumn) && Boolean(priceColumn);

const isIconTitleLayout = ({ iconColumn, bodyColumn }: ICartLayoutProps): boolean =>
  Boolean(iconColumn) && Boolean(bodyColumn);
